/* istanbul ignore file */
import React from 'react';
import { Button, ButtonColor, ButtonSize, FormButtonLayoutProps } from 'ui-builder';

function SubmitButtonLayout(props: FormButtonLayoutProps) {
  return (
    <Button
      isFilled={props.isFilled}
      text={props.text}
      size={props.size || ButtonSize.BIG}
      color={props.color || ButtonColor.GREEN}
      iconType={props.iconType}
      onClick={props.onClick}
      testId={props.testId}
      isDisabled={props.isDisabled}
      isSubmitButton
    />
  );
}

export default SubmitButtonLayout;
